import { render, staticRenderFns } from "./SocialLearning.vue?vue&type=template&id=30191818&"
import script from "./SocialLearning.vue?vue&type=script&lang=js&"
export * from "./SocialLearning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports